import { Checkbox, FormControl, InputLabel, ListItemText, MenuItem, OutlinedInput, Select, ThemeProvider } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import Chart from 'react-apexcharts';
import { useTranslation } from 'react-i18next';

import { SelectComponent } from '../../../Components/shared/ReusableSmallComponents';
import SelectPeriod from '../../../Components/shared/SelectPeriod';
import { PeriodeEchancier } from '../../../data/Interfaces';
import useWindowSize from '../../../hooks/useWindowSize';
import { FieldComponentFont } from '../../../Styles/componentStyles';
import { filtreListPeriodeMonthYear } from '../DashbordBackOffice';
import { statutPaiement } from './InterfacesDashboards';

function MargeBruteMargeNette({filtreClient,chiffreAffaire,selectedClient,height,width}){

    MargeBruteMargeNette.propTypes = {
        chiffreAffaire:PropTypes.any,
        filtreClient: PropTypes.any,
        selectedClient:PropTypes.any,
        width:PropTypes.any,
        height:PropTypes.any,
    };
    const [selectedStatutPaiementMargeNetBrute, setSelectedStatutPaiementMargeNetBrute] = useState('all'); // Default selected period
    const [selectedClientCheckBoxMargeNetBrute,setSelectedClientCheckBoxMargeNetBrute]=useState(['all']);
    const { inputSize } = useWindowSize();
    const ITEM_HEIGHT = 48;
    const [selectedPeriod, setSelectedPeriod] = useState('custom'); // Default selected period
    const [chartDataMargeBruteNet, setChartDataMargeBruteNet] = useState({
        series: [],

        options: {
            labels: [],
            chart: {
                type: 'bar',
                //stackType: '50%',
                //toolbar: {
                //    show: true
                //},
                zoom: {
                    enabled: true,
                    //type: 'xy', // Use 'xy' for 2D zoom (x and y-axis) or 'y' for only y-axis zoom
                },
            },
            bar : {
                columnWidth: '50px',
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    //distributed: true, // this line is mandatory
                    columnWidth: '15%', // Set the desired bar width as a percentage of the available space
                }
            },
            dataLabels: {
                enabled: false
            },
            //plotOptions: {
            //    bar: {
            //        horizontal: false,
            //        columnWidth: '10%', // Adjust the width of the bars here
            //        dataLabels: {
            //            enabled: false, // Set this to false to hide data labels
            //        },
            //    },
            //},

            legend: {
                position: 'bottom',
                offsetY: 40
            },
            fill: {
                opacity: 1,
            },
        },
    });

    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250,
            },
        },
    };

    const currentDate = new Date();
    currentDate.setMonth(currentDate.getMonth() - 2);
    const { i18n } = useTranslation();

    const [customDateRange, setCustomDateRange] = useState({
        from: currentDate.toISOString().slice(0, 10), // Get formatted date
        to: new Date().toISOString().slice(0, 10), // Get current date in YYYY-MM-DD format
    });

    const calculateMargeNetBruteByPeriode = (data) => {
        const sumByPeriode = {};

        data.forEach((item) => {
            const periode = item.periode;
            const totalBrute = parseFloat(item.margeBrute);
            const totalNet = parseFloat(item.margeNet);

            if (!sumByPeriode[periode]) {
                sumByPeriode[periode] = {
                    count: 1,
                    periode: periode,
                    totalMargeBrute: totalBrute,
                    totalMargeNet:totalNet,
                };
            } else {
                sumByPeriode[periode].count += 1;
                sumByPeriode[periode].totalMargeBrute += totalBrute;
                sumByPeriode[periode].totalMargeNet += totalNet;
            }

        });

        return sumByPeriode;
    };

    useEffect(()=>{
        if(Array.isArray(chiffreAffaire)){
            //const firstFiltrePeriode=filtreListPeriode(allStatusMissions,selectedPeriodMission,customDateRangeMission);
            let filteredData;

            filteredData = chiffreAffaire.filter(
                (item) => (item.typeFacture!='factureX' && item.typeFacture!='factureXgroupe' && item.typeFacture!='factureNgroupe')
            );
            console.log('second f margeNet Brute n',filteredData);
            if(filtreClient)
                if (!selectedClientCheckBoxMargeNetBrute.includes('all')) {
                    filteredData = filteredData.filter(
                        (item) => selectedClientCheckBoxMargeNetBrute.includes(item.companyDataId)
                    );
                }

            console.log('firt f margeNet Brute',filteredData);
            if (selectedStatutPaiementMargeNetBrute != 'all') {
                filteredData = filteredData.filter(
                    (item) => item.statutPaimentClient == selectedStatutPaiementMargeNetBrute
                );
            }

            if(selectedPeriod)
                filteredData=filtreListPeriodeMonthYear(filteredData,selectedPeriod,customDateRange);

            console.log('second f margeNet Brute',filteredData);
            const counts=calculateMargeNetBruteByPeriode(filteredData);

            setChartDataMargeBruteNet((prevState) => {
                return {
                    ...prevState,

                    series: [
                        {
                            name: 'Marge brute',
                            data:Object.values(counts).map(item => typeof item.totalMargeBrute === 'string'
                                ? parseFloat(item.totalMargeBrute).toFixed(2)
                                : item.totalMargeBrute.toFixed(2)),
                        },
                        {
                            name: 'Marge nette',
                            data:Object.values(counts).map(item => typeof item.totalMargeNet === 'string'
                                ? parseFloat(item.totalMargeNet).toFixed(2)
                                : item.totalMargeNet.toFixed(2)),

                        }
                    ],
                    options: {
                        ...prevState.options,
                        xaxis: {
                            ...prevState.options.xaxis,
                            categories: Object.keys(counts)
                            //Array.isArray(CountsListStatusCandidatures) ? CountsListStatusCandidatures.map((item) => item.date) : [],
                        },
                    },
                };
            });
        }
    },[selectedClient,chiffreAffaire,customDateRange,selectedPeriod,selectedStatutPaiementMargeNetBrute,selectedClientCheckBoxMargeNetBrute]);

    return (
        <>
            <div
                className='graph1'
                style={{width:width,height:height}}
            >
                <h1 className='dashFrame5'>{i18n.t('Evolution de la marge brute et nette')}</h1>
                <div className='filtre1'>
                    <div style={{width:'25%'}}>
                        <ThemeProvider theme={FieldComponentFont}>
                            <FormControl style={{width:'100%'}}>
                                <InputLabel
                                    shrink={true}
                                    id="demo-multiple-checkbox-label"
                                >{i18n.t('Clients')} </InputLabel>
                                <Select
                                    labelId="demo-multiple-checkbox-label"
                                    id="demo-multiple-checkbox"
                                    multiple
                                    value={selectedClientCheckBoxMargeNetBrute}
                                    onChange={(event)=>{
                                        const {
                                            target: { value },
                                        } = event;
                                        console.log('typeof value ===',typeof value === 'string' ? value.split(',') : value);
                                        setSelectedClientCheckBoxMargeNetBrute(
                                        // On autofill we get a stringified value.
                                            typeof value === 'string' ? value.split(',') : value,
                                        );
                                        if(value.length>0){
                                            if (value[value.length - 1] == 'all') {
                                                setSelectedClientCheckBoxMargeNetBrute(['all']);
                                            } else {
                                                // If 'all' was selected before, remove it from selectedClientCheckBox
                                                const updatedSelected = value.includes('all')
                                                    ? value.filter((item) => item !== 'all')
                                                    : value;
                                                console.log('updatedSelected',updatedSelected);

                                                setSelectedClientCheckBoxMargeNetBrute(updatedSelected);
                                            }
                                        }
                                    }}
                                    size={inputSize}
                                    sx={{
                                        '& > :not(style)': {borderRadius: '8px' },
                                    }}
                                    style={{ width: '100%', background: 'white' }}
                                    input={<OutlinedInput label="Clients" />}
                                    renderValue={(selected) => {
                                        return selected
                                            .map((id) => {
                                                const selectedOption = selectedClient.find(
                                                    (element) => element._id === id
                                                );
                                                return i18n.t(selectedOption?.label);
                                            })
                                            .join(', ');
                                    }}
                                    MenuProps={MenuProps}
                                >
                                    {Array.isArray(selectedClient) && selectedClient?.map((element) => (
                                        <MenuItem
                                            key={element._id}
                                            value={element._id}
                                        >
                                            <Checkbox checked={selectedClientCheckBoxMargeNetBrute.includes(element._id)} />
                                            <ListItemText primary={i18n.t(element.label)} />
                                        </MenuItem>
                                    ))}

                                </Select>
                            </FormControl>
                        </ThemeProvider>
                    </div>

                    <div style={{width:'25%'}}>
                        <SelectComponent
                            label={i18n.t('Statut paiement/Client')}
                            val={selectedStatutPaiementMargeNetBrute}
                            name='Statut paiement/Client'
                            setVal={(e) => {
                                setSelectedStatutPaiementMargeNetBrute(e.target.value);
                            }}
                            listVal={statutPaiement}
                        />
                    </div>

                    <div style={{width:'25%'}}>
                        <SelectPeriod
                            selectedPeriod={selectedPeriod}
                            setSelectedPeriod={setSelectedPeriod}
                            setCustomDateRange={setCustomDateRange}
                            listeVal={PeriodeEchancier}

                        />
                    </div>
                </div>
                <div style={{height:'400px'}}>
                    <Chart
                        options={chartDataMargeBruteNet.options}
                        series={chartDataMargeBruteNet.series}
                        type="bar"
                        width={'100%'}
                        height={'85%'}
                    />
                </div>
            </div>
        </>
    );

}
export default MargeBruteMargeNette;